import React, { useState } from "react";
import { ChevronDown, Mail, Trash2 } from "lucide-react";
import { Checkbox } from "../ui/checkbox";

const fmt = (d) =>
  new Date(d).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export default function EnquiryRow({ r, selected, onToggle, onDelete }) {
  const [open, setOpen] = useState(false);
  return (
    <li data-testid={`admin-enquiry-${r.id}`} className={selected ? "bg-sky-50/50" : ""}>
      <div className="flex flex-wrap items-center gap-3 px-5 py-4">
        <Checkbox checked={selected} onCheckedChange={onToggle} data-testid={`admin-select-${r.id}`} />
        <button onClick={() => setOpen(!open)} data-testid={`admin-enquiry-toggle-${r.id}`}
          className="flex-1 min-w-[220px] flex items-center gap-3 text-left">
          <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
          <div className="min-w-0">
            <div className="font-medium text-slate-900 truncate">{r.name}{r.company && <span className="text-slate-500 font-normal"> · {r.company}</span>}</div>
            <div className="text-xs text-slate-500">{fmt(r.created_at)} · {r.service || "No service chosen"}</div>
          </div>
        </button>
        <button onClick={onDelete} data-testid={`admin-delete-${r.id}`} aria-label={`Delete enquiry from ${r.name}`}
          className="h-9 w-9 rounded-full flex items-center justify-center text-slate-400 hover:text-red-600 hover:bg-red-50 transition-colors">
          <Trash2 className="h-4 w-4" />
        </button>
      </div>
      {open && <EnquiryDetail r={r} />}
    </li>
  );
}

const EnquiryDetail = ({ r }) => {
  const terms = r.web_terms_agreed == null ? null : r.web_terms_agreed ? `Agreed ${fmt(r.web_terms_agreed_at)}` : "Not agreed";
  const fields = [["Email", r.email], ["Phone", r.phone], ["Budget", r.budget], ["Web Design Terms", terms]].filter(([, v]) => v);
  return (
    <div className="px-5 pb-5 pl-12 text-sm" data-testid={`admin-enquiry-detail-${r.id}`}>
      <dl className="grid sm:grid-cols-3 gap-3">
        {fields.map(([k, v]) => (
          <div key={k}><dt className="text-xs text-slate-500">{k}</dt><dd className="text-slate-900 break-words">{v}</dd></div>
        ))}
      </dl>
      <p className="mt-4 whitespace-pre-wrap text-slate-700 bg-slate-50 rounded-xl p-4 border border-slate-100">{r.message}</p>
      <a href={`mailto:${r.email}`} data-testid={`admin-reply-${r.id}`}
        className="mt-4 inline-flex items-center gap-1.5 text-sky-700 font-medium hover:underline">
        <Mail className="h-4 w-4" /> Reply to {r.name.split(" ")[0]}
      </a>
    </div>
  );
};
